import { useVenueContext } from "contexts/VenueContext";

import { VenueSelectProps } from "./types";

import VenueSelect from ".";

const VenueContextSelect: React.FC<
  Omit<VenueSelectProps, "value" | "onChange">
> = (props) => {
  const { venue, setVenue } = useVenueContext();

  return <VenueSelect value={venue} onChange={setVenue} {...props} />;
};

export default VenueContextSelect;
